// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kesejxmbfvpkgnwofiys.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtlc2VqeG1iZnZwa2dud29maXlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkyNzM0NjIsImV4cCI6MjA1NDg0OTQ2Mn0.uhIvHz-e0hDXH71YdPXlFlDK-aBCyjbttNi4qMy_PwE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});